import React from 'react';
import { Button } from 'flowbite-react';
import { useGetVotesByQuestion, useGetUserVote } from 'src/hooks/support.hooks';
import { VoteType } from 'types';

interface QuestionVoteButtonsProps {
    questionId: string;
    question: string;
    onVote: (questionId: string, question: string, voteType: VoteType) => void;
    isLoading: boolean;
    /** Rendered after vote buttons; receives current vote counts. Use to e.g. show "Raise a Support Ticket" only when downvotes > 0. */
    renderExtra?: (votes: { upvotes: number; downvotes: number }) => React.ReactNode;
}

const QuestionVoteButtons: React.FC<QuestionVoteButtonsProps> = ({
    questionId,
    question,
    onVote,
    isLoading,
    renderExtra,
}) => {
    const { data: votesData } = useGetVotesByQuestion(questionId);
    const { data: userVoteData } = useGetUserVote(questionId);
    const userVote = userVoteData?.data;
    const upvotes = votesData?.data?.upvotes ?? 0;
    const downvotes = votesData?.data?.downvotes ?? 0;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4 pt-4 border-t">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    Was this information helpful?
                </span>
                <div className="flex gap-2">
                    <Button
                        size="sm"
                        color={userVote?.voteType === VoteType.UPVOTE ? 'purplePlaced' : 'gray'}
                        outline={userVote?.voteType !== VoteType.UPVOTE}
                        onClick={() => onVote(questionId, question, VoteType.UPVOTE)}
                        disabled={isLoading}
                    >
                        👍
                    </Button>
                    <Button
                        size="sm"
                        color={userVote?.voteType === VoteType.DOWNVOTE ? 'purplePlaced' : 'gray'}
                        outline={userVote?.voteType !== VoteType.DOWNVOTE}
                        onClick={() => onVote(questionId, question, VoteType.DOWNVOTE)}
                        disabled={isLoading}
                    >
                        👎
                    </Button>
                </div>
            </div>
            {renderExtra?.({ upvotes, downvotes })}
        </div>
    );
};

export default QuestionVoteButtons;
